import gql from 'graphql-tag';

const AUDIT_CHANGE_VECTOR = gql`
  query AuditChangeVector($auditChangeVectorId: String!) {
    auditChangeVector(id: $auditChangeVectorId) {
      _id
      type
      customer
      createdOn
      changeVector
    }
  }
`;

export default AUDIT_CHANGE_VECTOR;
